/*
  custom-rug-motion.js
  Motion layer for the Custom Rug (sm-*), Collection (smc-*) and Trade
  sections. Any element with [data-sm-reveal] also gets the scroll reveal.
  Heroes animate only if their inline script applied .sm-motion-wait
  before first paint (no flash, cache-proof, reduced-motion aware).
  Skipped inside the theme editor.
*/
(function () {
  function init() {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (window.Shopify && window.Shopify.designMode) return;
    gsap.registerPlugin(ScrollTrigger);

    var mm = gsap.matchMedia();
    mm.add(
      { motion: '(prefers-reduced-motion: no-preference)', reduce: '(prefers-reduced-motion: reduce)' },
      function (ctx) {
        if (ctx.conditions.reduce) return;

        /* ----- Hero entrances: one gentle rise each ----- */
        document.querySelectorAll('.sm-hero').forEach(function (hero) {
          if (!hero.classList.contains('sm-motion-wait')) return;
          var inner = hero.querySelector('.sm-hero__inner, .smc-hero__inner');
          hero.classList.add('sm-motion-run');
          if (inner) {
            gsap.fromTo(inner,
              { autoAlpha: 0, y: 24 },
              { autoAlpha: 1, y: 0, duration: 1.1, ease: 'power2.out', force3D: true, delay: 0.1 }
            );
          }
          hero.classList.remove('sm-motion-wait');
        });

        /* ----- Scroll reveals (once) ----- */
        var items = gsap.utils.toArray([
          '.sm-wrap .sm-eyebrow', '.sm-wrap h2', '.sm-lead',
          '.sm-path', '.sm-step', '.sm-note',
          '.sm-mat__card', '.sm-mat__band',
          '.sm-proj__item', '.sm-proj__quote',
          '.sm-trade__intro', '.sm-trade__item',
          '.sm-honest__col', '.sm-faq__list',
          '.sm-config__canvas', '.sm-config__controls',
          '.sm-contact__side', '.sm-form',
          '.smc-room', '.smc-xsell__pane', '.smc-seo__col',
          '[data-sm-reveal]'
        ].join(',')).filter(function (el) { return !el.closest('.sm-hero'); });

        if (items.length) {
          gsap.set(items, { autoAlpha: 0, y: 22 });
          ScrollTrigger.batch(items, {
            start: 'top 88%',
            once: true,
            onEnter: function (batch) {
              gsap.to(batch, { autoAlpha: 1, y: 0, duration: 0.9, ease: 'expo.out', stagger: 0.07, overwrite: 'auto' });
            }
          });
          ScrollTrigger.refresh();
        }

        /* ----- Process rail progress (scrubbed) ----- */
        document.querySelectorAll('[data-sm-railbar]').forEach(function (bar) {
          gsap.fromTo(bar, { scaleX: 0 }, {
            scaleX: 1,
            ease: 'none',
            transformOrigin: 'left center',
            scrollTrigger: {
              trigger: bar.closest('.sm-rail') || bar,
              start: 'top 75%',
              end: 'bottom 55%',
              scrub: 0.5
            }
          });
        });
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();